export default __webpack_public_path__ + "static/media/white02.8a35fed6.jpg";